/**
 * HR Microsite - Light Side
 */
(function ($) {

	$('#scroll-bottom').on('click', function (e) {
		e.preventDefault();

			$('html, body').animate({
    		scrollTop: $("#bottom").offset().top
    	}, 1000, 'linear');
	});

	$('.btn-long-top').on('click', function (e) {
		dataLayer.push({
				'event': 'fgWebAnalytics',
				'fgVarCat': 'Microsite svetla strana sily',
				'fgVarAct': 'Proklik tlacitka pridej se',
				'fgVarLbl': 'Dlouha - prvni sekce'
		});
	});

	$('.btn-long-bottom').on('click', function (e) {
		dataLayer.push({
				'event': 'fgWebAnalytics',
				'fgVarCat': 'Microsite svetla strana sily',
				'fgVarAct': 'Proklik tlacitka pridej se',
				'fgVarLbl': 'Dlouha - druha sekce'
		});
	});

	$('.btn-short-top').on('click', function (e) {
		dataLayer.push({
				'event': 'fgWebAnalytics',
				'fgVarCat': 'Microsite svetla strana sily',
				'fgVarAct': 'Proklik tlacitka pridej se',
				'fgVarLbl': 'Kratka - prvni sekce'
		});
	});

	$('.btn-short-middle').on('click', function (e) {
		dataLayer.push({
				'event': 'fgWebAnalytics',
				'fgVarCat': 'Microsite svetla strana sily',
				'fgVarAct': 'Proklik tlacitka pridej se',
				'fgVarLbl': 'Kratka - druha sekce'
		});
	});

	$('.btn-short-bottom').on('click', function (e) {
		dataLayer.push({
				'event': 'fgWebAnalytics',
				'fgVarCat': 'Microsite svetla strana sily',
				'fgVarAct': 'Proklik tlacitka pridej se',
				'fgVarLbl': 'Kratka - treti sekce'
		});
	});

	$('.btn-ana-top').on('click', function (e) {
		dataLayer.push({
				'event': 'fgWebAnalytics',
				'fgVarCat': 'Microsite svetla strana sily',
				'fgVarAct': 'Proklik tlacitka pridej se',
				'fgVarLbl': 'Analytik - prvni sekce'
		});
	});

	$('.btn-ana-middle').on('click', function (e) {
		dataLayer.push({
				'event': 'fgWebAnalytics',
				'fgVarCat': 'Microsite svetla strana sily',
				'fgVarAct': 'Proklik tlacitka pridej se',
				'fgVarLbl': 'Analytik - druha sekce'
		});
	});

	$('.btn-ana-bottom').on('click', function (e) {
		dataLayer.push({
				'event': 'fgWebAnalytics',
				'fgVarCat': 'Microsite svetla strana sily',
				'fgVarAct': 'Proklik tlacitka pridej se',
				'fgVarLbl': 'Analytik - treti sekce'
		});
	});

})(jQuery);







// WEBPACK FOOTER //
// ./fe/web-default/src/js/site/jQuery.lightSide.js